/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AreaV1Dto } from '../models/AreaV1Dto';
import type { CreateAreaV1Dto } from '../models/CreateAreaV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchAreaV1Dto } from '../models/PatchAreaV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AreasService {
  /**
   * @param requestBody
   * @returns AreaV1Dto create entity
   * @throws ApiError
   */
  public static areaControllerV1CreateV1(
    requestBody: CreateAreaV1Dto,
  ): CancelablePromise<AreaV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/areas',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns AreaV1Dto a entity list
   * @throws ApiError
   */
  public static areaControllerV1FindAllV1(): CancelablePromise<Array<AreaV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/areas',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static areaControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/areas',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid areaId
   * @returns AreaV1Dto the entity
   * @throws ApiError
   */
  public static areaControllerV1FindOneV1(uuid: string): CancelablePromise<AreaV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/areas/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid areaId
   * @param requestBody
   * @returns AreaV1Dto the update entity
   * @throws ApiError
   */
  public static areaControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchAreaV1Dto,
  ): CancelablePromise<AreaV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/areas/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid areaId
   * @returns AreaV1Dto the entity
   * @throws ApiError
   */
  public static areaControllerV1RemoveOneV1(uuid: string): CancelablePromise<AreaV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/areas/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid areaId
   * @returns AreaV1Dto a entity list
   * @throws ApiError
   */
  public static areaControllerV1FindManyByCustomerIdV1(
    uuid: string,
  ): CancelablePromise<Array<AreaV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/areas/customer/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
